import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
//import DialogContentText from '@mui/material/DialogContentText';
//import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

export default function FormDialog(props) {

  return (
    <>
      <Dialog open={props.open} onClose={(event, reason) => props.handleClose(event, reason)} disableEscapeKeyDown={true}
        maxWidth={props.maxWidth} fullWidth={true}>
        <>
          {props.titulo && <DialogTitle>{props.titulo}</DialogTitle>}          
          <DialogContent>
            <props.component/>
          </DialogContent>
        </>
      </Dialog>
    </>
  );
}



FormDialog.defaultProps = {
  open: false,
  component: null,
};